import {imagesRegister} from "./imagesRegister";

class quotesRegister {

    static quotes = null;
    static page_number = 0;
    static quotes_lang = null;
    static custom = null;
    static view = null;

    static setView(view){
        quotesRegister.view = view;
        try {
            sessionStorage.setItem('quotes_view', JSON.stringify(quotesRegister.view));
        }catch (e) {}
    }

    static setQuotes(data, page, lang, view){
        quotesRegister.quotes = data;
        quotesRegister.page_number = page;
        quotesRegister.quotes_lang = lang;
        try {
            sessionStorage.setItem('quotes', JSON.stringify(quotesRegister.quotes));
            sessionStorage.setItem('quotes_page', JSON.stringify(quotesRegister.page_number));
            sessionStorage.setItem('quotes_lang', JSON.stringify(quotesRegister.quotes_lang));
        }catch (e) {}
    }

    static getQuotes(data){
        let storage = JSON.parse(sessionStorage.getItem('quotes'));
        if(storage && !imagesRegister.quotes){
            return storage;
        }else{
            return imagesRegister.quotes;
        }
    }

    static removeQuotes(){
        quotesRegister.quotes = null;
        quotesRegister.page_number = 0;
        quotesRegister.quotes_lang = null;
        try {
            sessionStorage.removeItem('quotes');
            sessionStorage.removeItem('quotes_page');
            sessionStorage.removeItem('quotes_lang');
        }catch (e) {}
    }

    static getPage(){
        try {
            if(JSON.parse(sessionStorage.getItem('quotes_page'))){
                return JSON.parse(sessionStorage.getItem('quotes_page'))
            }else{
                return quotesRegister.page_number;
            }
        }catch (e) {
            return quotesRegister.page_number;
        }
    }

    static getLang(){
        try {
            if(JSON.parse(sessionStorage.getItem('quotes_lang'))){
                return JSON.parse(sessionStorage.getItem('quotes_lang'))
            }else{
                return quotesRegister.quotes_lang;
            }
        }catch (e) {
            return quotesRegister.quotes_lang;
        }
    }

    static getView(){
        try {
            if(JSON.parse(sessionStorage.getItem('quotes_view'))){
                return JSON.parse(sessionStorage.getItem('quotes_view'))
            }else{
                return quotesRegister.view;
            }
        }catch (e) {
            return quotesRegister.view;
        }
    }

    //SHORTENER
    static set(data, page, lang, view){
        quotesRegister.setQuotes(data, page, lang, view);
    }

    static get(){
        return quotesRegister.getQuotes();
    }

    static remove(){
        quotesRegister.removeQuotes();
    }

    static page(){
        return quotesRegister.getPage();
    }

    static lang(){
        return quotesRegister.getLang();
    }

}

export {quotesRegister}


// WEBPACK FOOTER //
// ./src/services/quotesRegister.js